import React, { Component } from 'react';
import { Select, Icon } from 'antd';
import Label from "./label";

const Option = Select.Option;
export default class DelaySelect extends Component {
    constructor(props) {
        super(props);
        let config = this.parseCStyle(props.cStyle);
        this.state = Object.assign({
            data: [],
            value: '',
            delayTime: props.delayTime || 300,
            placeholder: props.placeholder || '',
            // field props
            visible: !props.bHidden,
            className: props.className || '',
            bIsNull: props.bIsNull,
        }, config)
    }

    componentDidMount() {
        if (this.props.model)
            this.props.model.addListener(this)
    }

    componentWillUnMount() {
        if (this.props.model)
            this.props.model.removeListener(this)
    }

    setValue(item) {
        if (item && item.value) {
            this.selectValue = item.value;
            this.setState({ value: item.value })
        }
    }

    parseCStyle = (cStyle) => {
        let config = {}
        try {
            let configStyle = JSON.parse(cStyle) || {};
            config.delayTime = configStyle.delayTime;
            config.placeholder = configStyle.placeholder;

        } catch (e) {
            console.error(e);
        }
        return config
    }

    dispacher = (value) => {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.currentValue = value;

        const realAction = () => {
            if (this.props.model) {
                this.outputValue = this.currentValue;
                this.props.model.execute('delaySChange', this.outputValue)
            }
            // mock test
            // this.setDataSouce([{id: 0, value: 0},{id: 1, value: 1},
            //     ,{id: 2, value: 2},{id: 3, value: 3},{id: 4, value: 4},
            //     {id: 5, value: 5},{id: 6, value: 6},{id: 7, value: 7},
            //     {id: 8, value: 8},{id: 9, value: 9},{id: 10, value: 10}].splice(parseInt(Math.random()*10)), this.currentValue);
        }
        this.timeout = setTimeout(realAction, this.state.delayTime);
    }

    handleChange = (value) => {
        if (this.selectValue === value) return // onSelect不再触发onChage
        this.setState({ value });
        this.dispacher(value);
    }

    onSelect = (value, option) => {
        if (this.props.model) {
            const item = this.state.data.find(ele => ele.id == option.props["data-id"]);
            if (item)
                this.props.model.setValue(item, true);
            // this.props.model.execute('delaySelect' , item)
        }
    }

    setDataSouce = (data) => {
        if (this.currentValue == this.outputValue) {
            this.setState({ data })
        }
    }

    baseControl() {
        const options = this.state.data.map(d => <Option data-id={d.id} key={d.value}>{d.value}</Option>);
        return (
            <Select
                mode="combobox"
                value={this.state.value}
                placeholder={this.state.placeholder}
                notFoundContent=""
                style={this.state.style}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onChange={this.handleChange}
                onSelect={this.onSelect}
            >
                {options}
            </Select>
        );
    }

    relatedControl() {
        const control = this.baseControl();
        const { relatedControl } = this.props;
        if (!relatedControl)
            return control;
        return (
            <div className={'has-related has-related-select ' + (this.state.cItemName || '')}>
                <div className='viewCell'>{control}</div>
                {relatedControl}
            </div>
        );
    }

    getControl() {
        const { cShowCaption } = this.props;
        const title = !this.state.readOnly && this.state.bIsNull === false && cShowCaption ? <label><Icon type='star' />{cShowCaption}</label> : <label>{cShowCaption}</label>;
        let control = (cShowCaption ? <Label control={this.relatedControl()} title={title} /> : this.relatedControl());
        return control;
    }

    render() {
        const control = this.getControl();
        let style = this.state.visible ? {} : { display: "none" };
        let className = this.state.err + ' ' + this.state.className + ' ' + (this.state.classname ? `${this.state.classname} ` : '');
        if (this.state.readOnly) className = className + " readonly";
        return (
            <div ref="div" style={style} className={className}>
                {control}
                <div className="ant-form-explain">{this.state.msg}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/delaySelect.jsx